import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { ReactElement, useState } from 'react';
import { useHistory } from 'react-router';
import { EnableFor } from '../../../../__legacy__/containers/EnableForRole';
import { HeaderWithDescription } from '../../../common/headerWithDescription/HeaderWithDescription';
import { RowLayout } from '../../../common/layouts/rowLayout/RowLayout';
import { SpaceBetweenLayout } from '../../../common/layouts/spaceBetweenLayout/SpaceBetweenLayout';
import { ICurrentWorkspaceStore } from '../../../workspaces/currentWorkspace/CurrentWorkspace.store';
import { useJobPermissions } from '../../jobPermissions';
import { JOB_TYPE } from '../../jobs.model';
import { IJobsService } from '../../jobs.service';
import { getJobRoutePrefix, getJobTranslationPrefix } from '../../utils';
import { ImportModalContainer } from './ImportModal.container';

interface IJobsHeaderContainerProps {
  jobType: JOB_TYPE;
}

export const JobsHeaderContainer = ({ jobType }: IJobsHeaderContainerProps): ReactElement => {
  const jobsService = useInjection(IJobsService.$);
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);
  const history = useHistory();
  const permissions = useJobPermissions();

  const { t } = useTranslator();
  const [showImportModal, setShowImportModal] = useState(false);
  const isTraining = jobType === JOB_TYPE.TRAINING;
  const translationPrefix = getJobTranslationPrefix(jobType);

  const handleNewJobClicked = (): void => {
    const route = jobType === JOB_TYPE.TRAINING ? getJobRoutePrefix(jobType).Create.Settings : getJobRoutePrefix(jobType).Create.Datasets;
    history.push(route.withParams({ workspaceId: currentWorkspaceStore.currentWorkspace.id }));
  };

  const handleImportNewModelClicked = (): void => {
    setShowImportModal((state) => !state);
  };

  const handleimportJobAsync = async (name: string, description: string, file: File): Promise<boolean> => {
    return await jobsService.importModelsAsync(name, description, file);
  };

  const clearImportErrors = (): void => {
    jobsService.clearImportErrors();
  };

  return (
    <div>
      <SpaceBetweenLayout>
        <HeaderWithDescription header={t(`${translationPrefix}.list.header`)} />
        <RowLayout size='md'>
          <EnableFor hasPermission={permissions.canRun()}>
            <Button onClick={handleNewJobClicked}>{t(`${translationPrefix}.run.new`)}</Button>
          </EnableFor>
          {isTraining && (
            <EnableFor
              hasPermission={permissions.canImport()}
              hideWhenNoAccess
            >
              <Button
                variant='outlined'
                onClick={handleImportNewModelClicked}
              >
                {t('training.import.button')}
              </Button>
            </EnableFor>
          )}
        </RowLayout>
      </SpaceBetweenLayout>
      {isTraining && (
        <ImportModalContainer
          showModal={showImportModal}
          toggleModal={handleImportNewModelClicked}
          importJobAsync={handleimportJobAsync}
          clearImportErrors={clearImportErrors}
        />
      )}
    </div>
  );
};
